import { render, staticRenderFns } from "./DefaultKey.vue?vue&type=template&id=01fa30d8"
import script from "./DefaultKey.vue?vue&type=script&lang=js"
export * from "./DefaultKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports